// Copyright ©️ 2026 eVolve MEP, LLC

import type { Label, LabelId } from '@evolvemep/api-ts';

import { WORK_ORDER_LABEL_TYPE_ID } from 'components/Mantine/Labels/constants';
import { LabelWithColorSwatch } from 'components/Mantine/Labels/LabelBadges';
import { WrappedCheckList } from 'components/Mantine/TypeSafeSelect/WrappedCheckList';
import type { EditorComponent } from 'helpers/ag-grid/EditableCells/EditableCell';
import { isNotNil } from 'helpers/isNotNil';
import { useLabels } from 'hooks/typeCacheHooks/useLabels/useLabels';

export const WorkOrdersLabelChecklist: EditorComponent<Label[]> = (props) => {
  const { labels, labelMap, loading } = useLabels(WORK_ORDER_LABEL_TYPE_ID);
  const data = labels.map((label) => ({
    value: label.labelId,
    original: label,
    label: <LabelWithColorSwatch label={label} />,
  }));

  const handleChange = (labelIds: LabelId[]) => {
    const selectedLabels = labelIds.map((id) => labelMap[id]).filter(isNotNil);
    props.onChange(selectedLabels);
  };

  return (
    <WrappedCheckList
      data={data}
      loading={loading}
      value={props.value?.map((label) => label.labelId)}
      onChange={handleChange}
      filterInclude={(d, searchPhrase) => d.original.name.toLowerCase().includes(searchPhrase.toLowerCase())}
    />
  );
};
